import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import {
  BasicCartesianChartEchartConfigTemplate,
  BasicCartesianChartAxisTemplate,
  BasicCartesianChartColourPalette,
} from '@app/data/widget-config-templates/basic-cartesian-chart';

// import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import { configureChart, generateSeries } from '@app/widgets/helpers/widget-helpers';

// export const PanoniMahurangiRiver: BasicCartesianChartConfig = configureChart(
//   'Panoni - Land Use Change Over Time: Mahurangi River',
//   generateSeries(
//     ['arc_Mahurangi_Argonaut_@_College'],
//     [
//       'relative-water-level',
//       'dissolved-oxygen-in-field',
//       'dissolved-oxygen-saturation-in-field',
//       'River flow',
//       'water-temperature',
//     ]
//   )
// );

// export const PanoniHoteoRiverGubbs: BasicCartesianChartConfig = configureChart(
//   'Panoni - Land Use Change Over Time: Hoteo River Gubbs',
//   generateSeries(['arc_Hoteo_River_@_Gubbs'], ['relative-water-level', 'River flow', 'water-temperature'])
// );

// export const PanoniLongbay: BasicCartesianChartConfig = configureChart(
//   'Panoni - Land Use Change Over Time: Long Bay',
//   generateSeries(
//     ['arc_Vaughn_Stream_@_Lower_Weir'],
//     ['dissolved-oxygen-in-field', 'dissolved-oxygen-saturation-in-field', 'relative-water-level', 'River flow']
//   )
// );

export const WaikanaeWhenua2: BasicCartesianChartConfig = configureChart(
  'WHENUA - Land Cover and Wai: Waikanae',
  generateSeries(['gw_waikanae_river_at_footbridge_on_mangaone_walkway'], ['turbidity', 'e.-coli'])
);

export const WaikanaeWhenua: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#8c7ebb', '#66c39b', '#007093'],
    grid: {
      top: '25%',
      left: '5%',
      right: '5%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'E. coli\nCFU/100mL',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Turbidity',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'E. coli',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'WHENUA - Land Cover and Wai: Waikanae',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_footbridge_on_mangaone_walkway',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_footbridge_on_mangaone_walkway',
        analyteIdentifier: 'e.-coli',
        valueField: 'avg',
        label: 'E. coli',
      },
    ],
  },
};

export const WaikanaeWaiFieldWaterSampling2: BasicCartesianChartConfig = configureChart(
  'WAI - Field Water Sampling: Waikanae',
  generateSeries(['gw_waikanae_river_at_footbridge_on_mangaone_walkway'], ['ph-in-lab', 'turbidity', 'black-disk'])
);

export const WaikanaeWaiFieldWaterSampling: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#f26b4b', '#00b1d8', '#26312b', '#00b1d8'],
    grid: {
      top: '30%',
      left: '5%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'pH',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        name: 'Black \nDisk\nm',
        position: 'right',
        offset: 60,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
          formatter: (value: any) => Math.round(parseFloat(value)).toString(),
        },
        type: 'value',
        boundaryGap: [0, '100%'],
        alignTicks: true,
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'pH',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Black Disc',
      },
    ],
  },
  dataConfig: {
    title: 'WAI - Field Water Sampling: Waikanae',
    widgetId: 2,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_footbridge_on_mangaone_walkway',
        analyteIdentifier: 'ph-in-lab',
        valueField: 'avg',
        label: 'pH',
      },
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_footbridge_on_mangaone_walkway',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_footbridge_on_mangaone_walkway',
        analyteIdentifier: 'black-disk',
        valueField: 'avg',
        label: 'Black Disc',
      },
    ],
  },
};

export const PekaPekaContaminants2: BasicCartesianChartConfig = configureChart(
  'Peka Peka Contaminants',
  generateSeries(['gw_peka_peka_beach_at_road_end'], ['enterococci-bacteria'])
);

export const PekaPekaContaminants: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    grid: {
      ...BasicCartesianChartEchartConfigTemplate.grid,
      right: '7%',
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'n/100ml',
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Enterococci Bacteria',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'Peka Peka Contaminants',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_peka_peka_beach_at_road_end',
        analyteIdentifier: 'enterococci-bacteria',
        valueField: 'avg',
        label: 'Enterococci Bacteria',
      },
    ],
  },
};

export const PaekakarikiContaminants2: BasicCartesianChartConfig = configureChart(
  'Paekākāriki Contaminants',
  generateSeries(['gw_paekakariki_beach_at_surf_club'], ['enterococci-bacteria'])
);

export const PaekakarikiContaminants: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    grid: {
      ...BasicCartesianChartEchartConfigTemplate.grid,
      right: '7%',
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'n/100ml',
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Enterococci Bacteria',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'Paekākāriki Contaminants',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_paekakariki_beach_at_surf_club',
        analyteIdentifier: 'enterococci-bacteria',
        valueField: 'avg',
        label: 'Enterococci Bacteria',
      },
    ],
  },
};

export const ParaparaumuTaiao2: BasicCartesianChartConfig = configureChart(
  'TAIAO - Ecosystem Health: Paraparaumu (Beach at Ngapotiki Street)',
  generateSeries(['gw_paraparaumu_beach_at_ngapotiki_street'], ['enterococci-bacteria', 'turbidity'])
);

export const ParaparaumuTaiao: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#26312b', '#ee4891', '#8c7ebb'],
    grid: {
      top: '25%',
      left: '5%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Enterococci\nn/100ml',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Enterococci Bacteria',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
    ],
  },
  dataConfig: {
    title: 'TAIAO - Ecosystem Health: Paraparaumu (Beach at Ngapotiki Street)',
    widgetId: 2,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_paraparaumu_beach_at_ngapotiki_street',
        analyteIdentifier: 'enterococci-bacteria',
        valueField: 'avg',
        label: 'Enterococci Bacteria',
      },
      {
        environmentalDataSourceIdentifier: 'gw_paraparaumu_beach_at_ngapotiki_street',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
    ],
  },
};

export const WhareroaBeachRiverFlow2: BasicCartesianChartConfig = configureChart(
  'Stream Flow: Whareroa Beach at Wainui Stream',
  generateSeries(['gw_kcdc_wainui_stream'], ['River flow'])
);

export const WhareroaBeachRiverFlow: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    grid: {
      ...BasicCartesianChartEchartConfigTemplate.grid,
      right: '7%',
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'm³/s',
        axisLine: {
          show: true,
          lineStyle: {
            color: BasicCartesianChartColourPalette[1],
          },
        },
        axisLabel: {
          color: BasicCartesianChartColourPalette[1],
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Stream Flow',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'Stream Flow: Whareroa Beach at Wainui Stream',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_kcdc_wainui_stream',
        analyteIdentifier: 'River flow',
        valueField: 'avg',
        label: 'Stream Flow',
      },
    ],
  },
};

export const TeHoroWhakaaweWhenua2: BasicCartesianChartConfig = configureChart(
  'WHENUA - Land Cover and Wai: Te Horo',
  generateSeries(['gw_mangaone_stream_at_ratanui'], ['River flow', 'water-temperature']).concat(
    generateSeries(['gw_mangaone_stream_at_sims_road_bridge'], ['e.-coli', 'turbidity'])
  )
);

export const TeHoroWhakaaweWhenua: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#8c7ebb', '#66c39b', '#007093'],
    grid: {
      top: '25%',
      left: '10%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Flow Rate\nm³/s',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'E. coli\nCFU/100mL',
        offset: 60,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        offset: 60,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Water Temp\n°C',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Flow Rate',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'E. coli',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Water Temp',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'WHENUA - Land Cover and Wai: Te Horo',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_mangaone_stream_at_ratanui',
        analyteIdentifier: 'River flow',
        valueField: 'avg',
        label: 'Flow Rate',
      },
      {
        environmentalDataSourceIdentifier: 'gw_mangaone_stream_at_sims_road_bridge',
        analyteIdentifier: 'e.-coli',
        valueField: 'avg',
        label: 'E. coli',
      },
      {
        environmentalDataSourceIdentifier: 'gw_mangaone_stream_at_sims_road_bridge',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'gw_mangaone_stream_at_ratanui',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Water Temp',
      },
    ],
  },
};

export const TaiaoTeHoro2: BasicCartesianChartConfig = configureChart(
  'TAIAO - Ecosystem Health: Te Horo | Mangaone Stream at Sims Road Bridge',
  generateSeries(
    ['gw_mangaone_stream_at_sims_road_bridge'],
    ['dissolved-inorganic-nitrogen', 'turbidity', 'Total Nitrogen', 'dissolved-reactive-phosphorous']
  )
);

export const TaiaoTeHoro: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#26312b', '#ee4891', '#8c7ebb'],
    grid: {
      top: '25%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DIN\ng/m³',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'left',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TN\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DRP\ng/m³',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Dissolved Inorganic Nitrogen',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Nitrogen',
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Dissolved Reactive Phosphorus',
      },
    ],
  },
  dataConfig: {
    title: 'TAIAO - Ecosystem Health: Te Horo | Mangaone Stream at Sims Road Bridge',
    widgetId: 2,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_mangaone_stream_at_sims_road_bridge',
        analyteIdentifier: 'dissolved-inorganic-nitrogen',
        valueField: 'avg',
        label: 'Dissolved Inorganic Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'gw_mangaone_stream_at_sims_road_bridge',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'gw_mangaone_stream_at_sims_road_bridge',
        analyteIdentifier: 'Total Nitrogen',
        valueField: 'avg',
        label: 'Total Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'gw_mangaone_stream_at_sims_road_bridge',
        analyteIdentifier: 'dissolved-reactive-phosphorous',
        valueField: 'avg',
        label: 'Dissolved Reactive Phosphorus',
      },
    ],
  },
};

export const TaiaoOtaraua2: BasicCartesianChartConfig = configureChart(
  'TAIAO - Ecosystem Health: Otaraua | Waikanae River at Greenaway Rd',
  generateSeries(
    ['gw_waikanae_river_at_greenaway_rd'],
    ['dissolved-inorganic-nitrogen', 'turbidity', 'Total Nitrogen', 'dissolved-reactive-phosphorous']
  )
);

export const TaiaoOtaraua: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#26312b', '#ee4891', '#8c7ebb'],
    grid: {
      top: '25%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DIN\ng/m³',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'left',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TN\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DRP\ng/m³',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Dissolved Inorganic Nitrogen',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Nitrogen',
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Dissolved Reactive Phosphorus',
      },
    ],
  },
  dataConfig: {
    title: 'TAIAO - Ecosystem Health: Otaraua | Waikanae River at Greenaway Rd',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_greenaway_rd',
        analyteIdentifier: 'dissolved-inorganic-nitrogen',
        valueField: 'avg',
        label: 'Dissolved Inorganic Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_greenaway_rd',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_greenaway_rd',
        analyteIdentifier: 'Total Nitrogen',
        valueField: 'avg',
        label: 'Total Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_greenaway_rd',
        analyteIdentifier: 'dissolved-reactive-phosphorous',
        valueField: 'avg',
        label: 'Dissolved Reactive Phosphorus',
      },
    ],
  },
};

export const WhakaaweWhenuaOtaraua2: BasicCartesianChartConfig = configureChart(
  'WHAKAAWE WHENUA - Land Use Impact: Otaraua | Waikanae River at Greenaway Rd',
  generateSeries(
    ['gw_waikanae_river_at_greenaway_rd'],
    ['total-phosphorus', 'total-kjeldahl-nitrogen', 'Total Nitrogen']
  )
);

export const WhakaaweWhenuaOtaraua: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#8c7ebb', '#66c39b', '#007093'],
    grid: {
      top: '25%',
      left: '10%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Total\nPhosphorus\ng/m³',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TKN\ng/m³',
        offset: 60,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TN\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Total Phosphorus',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Total Kjeldahl Nitrogen',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Nitrogen',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'WHAKAAWE WHENUA - Land Use Impact: Otaraua | Waikanae River at Greenaway Rd',
    widgetId: 3,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_greenaway_rd',
        analyteIdentifier: 'total-phosphorus',
        valueField: 'avg',
        label: 'Total Phosphorus',
      },
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_greenaway_rd',
        analyteIdentifier: 'total-kjeldahl-nitrogen',
        valueField: 'avg',
        label: 'Total Kjeldahl Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'gw_waikanae_river_at_greenaway_rd',
        analyteIdentifier: 'Total Nitrogen',
        valueField: 'avg',
        label: 'Water Temp',
      },
    ],
  },
};
